export default __webpack_public_path__ + "static/media/plus.8941e747.png";